/* eslint-disable react/no-array-index-key */
import React from 'react'
import PropTypes from 'prop-types'
import { withState } from 'recompose'
import muiThemeable from 'material-ui/styles/muiThemeable'
import styled from 'styled-components'
import cx from 'classnames'
import { TableColumn } from './tableElements'
import Wrapper from 'components/wrappers/Wrapper'
import Dissatisfied from 'material-ui/svg-icons/social/sentiment-very-dissatisfied'

const CustomTable = muiThemeable()(
  styled(
    withState('hoverIndex', 'setHoverIndex', null)(
      ({
        className,
        hoverIndex,
        setHoverIndex,
        // required props
        data,
        config,
        sortKey,
        sortType,
        onSortByKey,
      }) => {
        return (
          <div className={cx('custom-table', className)}>
            {!data.length ? (
              <Wrapper className={'empty-data'}>
                <Dissatisfied style={{ width: 100, height: 100 }} color={'#e5e5e5'} />
                <p>Sorry, There is no any items.</p>
              </Wrapper>
            ) : (
              config.map(
                (item, index) => {
                  const {
                    headerLabel,
                    accessor,
                    renderCell,
                    width,
                    sortable,
                    ...rest
                  } = item
                  return (
                    <TableColumn
                      className={cx(sortable && 'sortable')}
                      key={`${accessor}-${index}`}
                      hoverIndex={hoverIndex}
                      setHoverIndex={setHoverIndex}
                      accessor={accessor}
                      sortable={sortable}
                      showSorter={sortable && accessor === sortKey}
                      sortType={sortType}
                      onSortByKey={onSortByKey}
                      data={data}
                      width={width || `${100 / config.length}%`}
                      headerLabel={headerLabel || accessor}
                      renderCell={renderCell}
                      {...rest}
                    />
                  )
                },
              )
            )}
          </div>
        )
      },
    ),
  )`
  &.custom-table {
    display: flex;
    
    .empty-data {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      
      p {
        font-size: 2rem;
        color: #d5d5d5;
      }
    }
    
    .table-column {
      display: inline-block;
      
      &.sortable {
        .table-header {
          // color: ${({ muiTheme }) => muiTheme.palette.accent1Color};
          cursor: pointer;
        }
      }
      
      .table-header {
        height: 50px;
        display: flex;
        align-items: center;
        padding-left: 2rem;
        background: #f5f5f5;
        width: 100%;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.7);
      }
      
      .table-cell {
        height: 50px;
        padding-left: 2rem;
        background-color: #ffffff;
        display: flex;
        align-items: center;
        width: 100%;
        box-shadow: inset 0 -1px 0 0 #f5f5f5;
        
        &.active {
          background-color: #fafafa;
        }
        
        &.more-actions {
          justify-content: flex-end;
          padding-right: 2rem;
        }
      }
    }
  }
`,
)

CustomTable.propTypes = {
  config: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
}
CustomTable.defaultProps = {}

export default CustomTable



// WEBPACK FOOTER //
// ./src/components/Table/CustomTable.js